export default __webpack_public_path__ + "static/N0086-ab0ca83e46f57ba999cf4a010074ed5e.png";